import React from 'react';
import cx from 'classnames';

import { CreamCircleIcon } from '@zola/zola-ui';

import { Store } from '@zola/zola-ui/src/assets/images/icons';
import AddToZola from 'assets/images/website/registryOnboard/AddToZola';
import HoneymoonCollage from 'assets/images/website/registryOnboard/HoneymoonCollage';

import BuildZolaRegistryCTA from '../../../components/BuildZolaRegistryCTA';
import AddARegistryLink from '../../../components/AddARegistryLink';

import styles from './AddExternalSection.module.less';

const tileContent = [
  {
    imgComponent: <img src={AddToZola} alt="add-to-zola" />,
    dek: 'Add Individual Gifts or an Entire Registry',
    ctaComponent: <BuildZolaRegistryCTA component="Link" ctaText="Build Your Registry" />,
  },
  {
    imgComponent: <CreamCircleIcon image={Store} />,
    dek: 'Link To Other Registries on Your Site',
    ctaComponent: <AddARegistryLink />,
  },
];
const honeymoonTileContent = {
  header: 'Add Anything Else You Want, Too',
  imgComponent: <img src={HoneymoonCollage} alt="honeymoon-collage" />,
  dek: 'Honeymoon & Cash Funds',
  ctaComponent: <BuildZolaRegistryCTA component="Link" ctaText="Build Your Registry" />,
};

const Tile = ({ content, ...props }) => {
  const { imgComponent, dek, ctaComponent, header } = content;
  return (
    <div {...props}>
      {header && <h3 className={cx(styles.tileDek, styles.centeredTitle)}>{header}</h3>}
      <div className={styles.tileBody}>
        {imgComponent}
        <div className={styles.tileContent}>
          <h4 className={styles.tileDek}>{dek}</h4>
          {ctaComponent}
        </div>
      </div>
    </div>
  );
};

const TileList = ({ tiles, orientation }) => {
  return (
    <div className={cx(styles.tileListContainer, styles[`tileListContainer--${orientation}`])}>
      {tiles.map((t, i) => (
        <Tile
          key={i}
          content={t}
          className={cx([
            styles.tileContainer,
            {
              [styles.tileSpacing]: i !== 0,
              [styles.tileSpacingRow]: i !== 0 && orientation === 'row',
            },
          ])}
        />
      ))}
    </div>
  );
};

const AddExternalSection = ({
  variant, // brandsSection variant
  ...props
}) => {
  return (
    <div {...props}>
      {!variant && (
        <h3 className={cx(styles.title, styles.centeredTitle)}>Add From Other Stores, Too</h3>
      )}
      <TileList
        orientation={variant ? 'column' : 'row'}
        tiles={variant ? [honeymoonTileContent, ...tileContent] : tileContent}
      />
    </div>
  );
};

export default AddExternalSection;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/AddExternalSection/AddExternalSection.jsx